export default "__VITE_ASSET__bikUMxlq__"